// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"9bda1c74","194":"9424e420","196":"d46fd454","293":"6ab85a17","561":"1d0241ac","981":"3bba83f5"}[chunkId] + ".chunk.css";
};